export default __webpack_public_path__ + "static/media/(26).92243020.jpeg";